import React, { useEffect } from "react";
import { useLoader } from "../components/common/Loader/LoaderProvider";
import WithoutAuthLayout from "../routeProtector/withoutAuth";
import Header from "../components/Home/Landing Page Components/Header";
import MainBanner from "../components/Home/Landing Page Components/MainBanner";
import UniqueSection from "../components/Home/Landing Page Components/UniqueSection";
import ClientReviews from "../components/Home/Landing Page Components/ClientReviews";
import DownloadSection from "../components/Home/Landing Page Components/DownloadSection";

const Home = () => {
  const loaderContext = useLoader();
  const { showLoader, hideLoader } = loaderContext;

  useEffect(() => {
    document.title = 'TXTBET'; // Quick solution
    hideLoader();
  }, []);
  return (
    <div>
      <Header />
      <MainBanner />
      <UniqueSection />
      <ClientReviews />
      <DownloadSection />
    </div>
  );
};

export default WithoutAuthLayout(Home);
